import { useSelector } from 'react-redux';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

export const UnifiedOnboardingRoutes = () => {
  const User = useSelector(state => state.User);
  const location = useLocation();


  const isInternalOrAdmin =User?.user_type === "Super Admin" || User?.user_type=="Verifier" || User.user_type=="Issuer";
  const allowAccess = (() => {
    if (isInternalOrAdmin) {
      return true;
    } else if(!User.user_name) {
      return true;
    }
  })()

  return allowAccess ? <Outlet /> : <Navigate to="/login" />;
}